import axios from 'axios'

import former from './former'

export default {

    mixins: [
        former
    ],

    data () {
        return {
            patcher: {
                submitted: false,
                unhandled_error: false
            }
        }
    },

    computed: {
        patcherUrl () {
            return ''
        },
        patcherData () {
            return {}
        }
    },

    methods: {

        patcherPatch () {
            if (this.patcher.submitted) {
                return
            }

            this.patcher.submitted = true
            this.patcher.unhandled_error = false
            this.former.unhandled_error = false

            axios.patch(
                this.patcherUrl,
                this.patcherData
            )
                .then(response => {
                    console.log('patcher response')
                    console.log(response.data)

                    this.patcherSuccess(response.data)

                    this.former.errors = {}
                    this.patcher.unhandled_error = false
                    this.former.unhandled_error = false
                })
                .catch(error => {
                    // alert('Sparing misslyckades, vänligen försök igen.')
                    console.log('patcher failed so patch')
                    console.log(error.response)

                    this.patcherFail(error.response)

                    if (error.response && error.response.status === 422) {
                        this.former.errors = error.response.data.errors
                        return
                    }

                    this.patcher.unhandled_error = true
                    this.former.unhandled_error = true
                })
                .then(avar => {
                    this.patcher.submitted = false
                })
        },

        patcherSuccess (data) {

        },

        patcherFail (response) {

        }

    }
}
